import { Card, CardContent, CardHeader, Divider, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Input, InputAdornment } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(0)
  },
  content: {
    padding: 0,
  },
}));

function List(props) {
  const classes = useStyles();

  const MalzemeSayimSil = (id) => {
    confirmAlert({
      message: "Silmek istediğinizden eminmisiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => props.SendUpdateWarehouseInventory(id, 0)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
    
  }

  const setInputSelection = (id, newValue) => {
    var a = document.getElementById(id);
    a.setSelectionRange(0, newValue.toString().length);
  }

  return (
    <div>
      <div className={classes.root}>
        <Card>
          <CardHeader title={'Depo Durumu'} />
          <Divider />
          <CardContent className={classes.content}>
            <TableContainer>
              <Table className={classes.tableD} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Malzeme</TableCell>
                    <TableCell align="center">Depo</TableCell>
                    <TableCell align="center">Adet</TableCell>
                    <TableCell align="center" >Sil</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.inventory.map(i => (
                    <TableRow key={i.materialId}>
                      <TableCell align="center">{i.materialCode}</TableCell>
                      <TableCell align="center">{i.warehouseDescription}</TableCell>
                      <TableCell align="center">
                        <Input
                          value={i.newCount || ''}
                          onChange={(e) => props.updateNewCount(i.id, e.target.value)}
                          inputProps={{
                            style: { width: '60px' },
                            id: "inventory_input_" + i.id.toString()
                          }}
                          onClick={() => setInputSelection("inventory_input_" + i.id.toString(), i.newCount)}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  if (i.count === i.newCount)
                                    return;
                                  else
                                    props.SendUpdateWarehouseInventory(i.id, i.newCount);
                                }}
                              >
                                {i.count === i.newCount ? <DoneIcon /> : <EditIcon />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </TableCell>
                    
                      <TableCell align="center" onClick={() => MalzemeSayimSil(i.id)} >
                        <IconButton color="primary">
                          <DeleteForeverIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default List;
